import { render, staticRenderFns } from "./ChaptersListDialog.vue?vue&type=template&id=18733119&scoped=true&"
import script from "./ChaptersListDialog.vue?vue&type=script&lang=js&"
export * from "./ChaptersListDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChaptersListDialog.vue?vue&type=style&index=0&id=18733119&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18733119",
  null
  
)

export default component.exports